import React from "react"
import { styled } from "styled-components"
import { black, white, yellow, red } from "./colors"

const Input = styled.input<{ $disableForceUppercase?: boolean }>`
  background-color: transparent;
  color: ${white};
  padding: 16px 8px;
  border-color: ${white};
  border-style: solid;
  border-width: 2px;
  border-radius: 8px;
  text-transform: ${({ $disableForceUppercase }) => $disableForceUppercase ? 'none' : 'uppercase'};
  font-size: 16px;
  font-family: inherit;
  font-weight: bold;
  caret-color: ${yellow};

  &::placeholder {
    color: ${white};
    font-weight: 100;
    text-transform: lowercase;
    opacity: 0.5;
  }

  &:focus,
  &:focus-visible {
    outline-color: ${yellow};
    border-color: ${yellow};
  }
  &:invalid {
    border-color: ${red};
  }
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > label {
    color: ${black};
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    background-color: ${yellow};
    width: fit-content;
    border-radius: 4px;
    padding: 2px 8px;
    position: relative;
    left: 16px;
    top: 10px;
  }
`
const ErrorMessage = styled.div`
  color: ${red};
  font-size: 14px;
  font-weight: bold;
  align-self: flex-start;
  margin-top: 4px;
  margin-left: 16px;
  text-transform: lowercase;
`

export const TextInput: React.FC<{
  allowClear?: boolean
  placeholder?: string
  type?: string
  disabled?: boolean
  disableForceUppercase?: boolean
  onChange: (value: string) => void
  onValidityChange?: (validity: boolean) => void
  value?: string
  label?: string
  className?: string
  required?: boolean
  error?: string
}> = ({
  type = "text",
  label,
  value = "",
  className = "",
  placeholder = "",
  required = false,
  onChange,
  onValidityChange,
  error,
  disabled = false,
  disableForceUppercase = false
}) => {
  const [touched, setTouched] = React.useState(false)
  const [internalErrorMessage, setInternalErrorMessage] = React.useState<
    string | null
  >(null)
  const inputName = `input-for-${label}`

  const handleInputEvent = event => {
    setTouched(true)
    setInternalErrorMessage(null)
  }

  const handleFocusOut = event => {
    const input = event.target
    const value = input.value
    const isValid = input.checkValidity()
    onValidityChange?.(isValid)
    if (isValid) {
      return
    }
    if (required && (!value || value.length === 0)) {
      return setInternalErrorMessage("This field cannot be left blank!")
    }
    if (type === "email") {
      return setInternalErrorMessage("Email is not valid!")
    }
  }

  return (
    <InputContainer className={className}>
      {label && <label htmlFor={inputName}>{label}</label>}
      <Input
        type={type}
        name={inputName}
        value={value}
        onChange={event => {
          return onChange(event.target.value as string)
        }}
        placeholder={placeholder}
        required={required && touched}
        onInput={handleInputEvent}
        onBlur={handleFocusOut}
        disabled={disabled}
        $disableForceUppercase={disableForceUppercase}
      />
      {(error || internalErrorMessage) && (
        <ErrorMessage>{error || internalErrorMessage}</ErrorMessage>
      )}
    </InputContainer>
  )
}
